import { type FC } from "react";

export type ForbiddenValueProps = Record<never, never>;

export const ForbiddenValue: FC<ForbiddenValueProps> = () => {
	return <span className="text-syntax-forbidden">[forbidden]</span>;
};
